define('acp-billing/acp-billing.module',['angular', './acp-billing.routes', './acp-billing.controllers', './acp-billing.services'], function(angular, routes, controllers) {
    'use strict';
    var mod = angular.module('com.cd.acp', ['ngRoute', 'acp-billing.routes', 'acp-billing.services']);
    mod.controller('EditInsuranceAcpCtrl', controllers.EditInsuranceCtrl);
    mod.controller('AddAddendumCtrl', controllers.AddAddendumCtrl);
    return mod;
});
